export enum SequenceCustomStepSenderTypeEnum {
  Email = 'EMAIL',
  Sms = 'SMS',
  InMail = 'INMAIL',
  Phone = 'PHONE',
}
